module.exports = __webpack_public_path__ + "img/ebo-logo.9cb40beb.png";